import React from "react";
import { Button } from "@/components/ui/button";
import { CheckCircle2 } from "lucide-react";
import AspApprovedModal from "@/components/staffing/modals/AspApprovedModal";
import { User } from "@/types/common/user";
import { ClientOption } from "@/types/staffing/serviceRequest";
import { AspWorkflowStep } from "@/types/staffing/asp";

interface SuccessScreenProps {
  selectedStaff: User | null;
  selectedClient: ClientOption | null;
  aspModalOpen: boolean;
  onAspModalOpenChange: (open: boolean) => void;
  aspWorkflowResults: AspWorkflowStep[] | undefined;
  /** Toast message returned by the scheduling save, if the request included a schedule. */
  scheduleMessage?: string | null;
  onReset: () => void;
  onBack?: () => void;
}

export function SuccessScreen({
  selectedStaff,
  selectedClient,
  aspModalOpen,
  onAspModalOpenChange,
  aspWorkflowResults,
  scheduleMessage,
  onReset,
  onBack,
}: SuccessScreenProps) {
  return (
    <>
      <div className="flex flex-col items-center gap-4 py-12 text-center">
        <div className="rounded-full bg-green-100 dark:bg-green-900/30 p-4">
          <CheckCircle2 className="h-10 w-10 text-green-600 dark:text-green-400" />
        </div>
        <div>
          <p className="text-base font-semibold text-foreground">
            Request submitted!
          </p>
          <p className="text-sm text-muted-foreground mt-1">
            Your service request has been sent successfully.
          </p>
          {scheduleMessage && (
            <p className="text-sm text-muted-foreground mt-2 max-w-md">
              Schedule: {scheduleMessage}
            </p>
          )}
        </div>
        <div className="flex items-center gap-2">
          <Button variant="outline" size="sm" onClick={onReset}>
            Submit another request
          </Button>
          {onBack && (
            <Button variant="ghost" size="sm" onClick={onBack}>
              Back to list
            </Button>
          )}
        </div>
      </div>
      {selectedStaff && selectedClient && (
        <AspApprovedModal
          open={aspModalOpen}
          onOpenChange={onAspModalOpenChange}
          staffLoginName={selectedStaff.LoginName}
          staffName={selectedStaff.FullName}
          clientId={selectedClient.id}
          initialResults={aspWorkflowResults}
        />
      )}
    </>
  );
}
